import React from 'react';
import HoldedExportsList from '../../components/exports/HoldedExportsList';

const ClientHoldedExports = () => {
  return (
    <HoldedExportsList
      title="Exportaciones Holded"
      description="Estado de facturas y gastos exportados a Holded."
    />
  );
};

export default ClientHoldedExports;
